import * as _ from "lodash"
import { getExtrasForGivenPhoneAndPlan } from "../../../redux/selectors/extras-selector"

// A helper function to add up the costs
export const addCosts = (costA, costB) => ({
  ...costA,
  ...Object.keys(costB).reduce(
    (agg, costType) => ({
      ...agg,
      [costType]: _.get(costA, costType, 0) + costB[costType]
    }),
    {}
  )
})

export const getTotalCosts = (
  phoneID,
  planID,
  extraIDs,
  condition
) => state => {
  let totalCosts = {}

  // Get the phone
  // If it has costs, let's get them
  if (!phoneID) {
    // no phone, so quit out
    return totalCosts
  }
  const phoneData = state.devices.byID[phoneID]
  if (phoneData.costs) {
    totalCosts = addCosts(totalCosts, phoneData.costs)
  }

  // Get the plan
  // If it has costs, let's get them and total
  if (!planID) {
    // no plan, so quit out here
    return totalCosts
  }
  const planCosts = state.plans.byID[condition][planID].devices[phoneID]
  totalCosts = addCosts(totalCosts, planCosts)

  // Go through the extras
  // Add their costs if they exist
  if (extraIDs && extraIDs[0] !== "") {
    totalCosts = extraIDs.reduce((totalCosts, extraID) => {
      return addCosts(totalCosts, {
        maf: getExtrasForGivenPhoneAndPlan(phoneID, planID)(state)[extraID].cost
      })
    }, totalCosts)
  }
  // return a costs object

  return {
    ...totalCosts
  }
}

export const getDeviceName = id => state => state.devices.byID[id].name

export const getPlanData = (id, condition) => state => {
  return state.plans.byID[condition][id].data
}

// Get the VAT info for this condition
export const getVatInfo = condition => state => {
  const { excludeVAT, vatDivider } = state.plans.options[condition]
  return {
    excludeVAT,
    vatDivider
  }
}

export const getPlanCost = (deviceID, planID, condition) => state =>
  state.plans.byID[condition][planID].devices[deviceID]

export const getExtras = (deviceID, planID, extraIDs) => state => {
  if (!extraIDs || extraIDs[0] === "") {
    return []
  }

  const possibleExtras = getExtrasForGivenPhoneAndPlan(deviceID, planID)(state)

  return extraIDs.map(extraID => possibleExtras[extraID])
}

export const getEntertainmentCost = (entertainment, deviceID) => state => {
  if (deviceID === "SIMO" && entertainment) {
    return state.benefits.byID["SIMO_ENTERTAINMENT_PROVIDERS"].monthly
  } else if (entertainment) {
    return state.benefits.byID["ENTERTAINMENT_PROVIDERS"].monthly
  } else {
    return 0
  }
}
